<template>
  <section id="confirmation">
    <div class="container" v-if="confirmation">
      <div class="content">
        <div class="body text-big text-center">
          Your reservation has been submitted.<br><br>

          You will receive an email and a text with your reservation details <span  v-if="confirmation.email">at {{ confirmation.email }}</span>.<br><br>
        </div><!-- .body -->
      </div><br>

      <div class="row no-print">
        <div class="col-12 text-right">
          <a class="btn btn-primary mt-5" href="#/home">Done</a>
        </div><!-- end .col-12 -->
      </div><!-- end .row -->
    </div><!-- end .container -->
  </section>
</template>

<script>
import { getConfirmation } from '@/api/reservation'
export default {
  name: 'ReservationSuccess',
  data() {
    return {
      loading: false,
      reservationId: '',
      confirmation: ''
    }
  },
  created() {
    this.loading = true
    this.reservationId = this.$route.params.id
    getConfirmation(this.reservationId).then(response => {
      if (response.data.success == true) {
        this.confirmation = response.data.data[0]
      }
      this.loading = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// success.vue?819dd57c